import React from 'react'

interface OrganisationsProviderValue {
  excludeOrganisationIds: number[] | null
  actions: {
    setExcludedOrganisationsIds: (orgIds: number[]) => void
  }
}

const OrganisationsContext = React.createContext<OrganisationsProviderValue | null>(null)

const OrganisationsProvider: React.FC<{ children?: React.ReactNode }> = (props) => {
  const [excludeOrganisationIds, setExcludedOrganisationsIds] = React.useState<number[] | null>(
    null,
  )
  const actions = React.useMemo(() => {
    return { setExcludedOrganisationsIds }
  }, [])

  const value = React.useMemo(
    () => ({ excludeOrganisationIds, actions }),
    [excludeOrganisationIds, actions],
  )

  return (
    <OrganisationsContext.Provider value={value}>
      {props.children}
    </OrganisationsContext.Provider>
  )
}

export { OrganisationsProvider, OrganisationsContext }
